import * as ko from "knockout";
import { searchCriteria } from "./_searchCriteria";

export class CarStockSearchCriteria extends searchCriteria {
  part_id: KnockoutObservable<string>;
  description: KnockoutObservable<string>;

  constructor(item) {
    super(item);

    this.part_id = ko.observable(item?.part_id);
    this.description = ko.observable(item?.description);
  }
}
